import { render, staticRenderFns } from "./Ver.vue?vue&type=template&id=5a21e7fb"
import script from "./Ver.vue?vue&type=script&lang=js"
export * from "./Ver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports